<template>
  <div class="container-404">
    <h1 class="heading-404">{{getNotFound.title}}</h1>
    <svg class="astronaut" id="Capa_2" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 518 618">
      <path class="cls-1" d="M509.14,414.84q-25.31-5.59-51-9.15-12.88-1.79-25.82-3.06c-6.66-.65-13.42-.95-19.93-2.64-5.37-1.4-10.85-3.88-13.76-8.86-3.06-5.23-2.07-11.58.87-16.63,7.55-13,24-13.61,37.3-13.87,6.42-.12,13.55-.67,18.5-5.26,4.35-4.05,5.29-10.27,3.5-15.77a22.61,22.61,0,0,0-11.13-13.1c-7.06-3.47-15.26-3.33-22.86-2.33-7.81,1-15.52,2.62-23.36,3.48a182.13,182.13,0,0,1-23.35,1.13c-15.37-.3-30.9-2.89-45-9.15a82.29,82.29,0,0,1-31.3-24.21,73.36,73.36,0,0,1-4.5-6.39l.2-.27c13.64-20.46,27.19-54.67,29.77-61.32a48.64,48.64,0,0,0,2.84-11,4.63,4.63,0,0,1,1.71,2c2.3,5.42,3,10.79,2.84,12.24l-7,45.21a21,21,0,1,0,41.5,6.42l7-45.21c1.54-9.94-.59-23-5.68-35.05a46.73,46.73,0,0,0-23.39-24.09l-9.27-4.33a20.11,20.11,0,0,0-5.13-2.6l-1.75-.61-1.9-.88a20.66,20.66,0,0,0-6.1-1.79c-35.31-11.11-61.59-10.17-76.34-8.21-6.94.92-11.34,2.06-12.9,2.26h0c-.71.1-1.43.22-2.15.39l-31.8,7.45a10.16,10.16,0,0,1-8.26-1.63l-33.91-23.61a21,21,0,0,0-24,34.47l33.62,23.4a52.16,52.16,0,0,0,42.13,8.26L220,208l-12.44,20.73c-5.91,9.85-23.57,12.14-33.57,12.63l-30.5,1.5a48.51,48.51,0,0,0-38.83,22.86l-21.48,34.6a23.13,23.13,0,1,0,39.3,24.41L144,290.13a2.26,2.26,0,0,1,1.79-1.05l30.5-1.49a136.58,136.58,0,0,0,18-2,48.89,48.89,0,0,0-29.42,55.73l8.58,40.16a23.13,23.13,0,1,0,45.24-9.66l-8.57-40.16a2.86,2.86,0,0,1,1.95-3.34L267,311.13a23.22,23.22,0,0,0,7.63-4.07,48.21,48.21,0,0,0,20-14.48A84.72,84.72,0,0,0,320,317.42c12.77,8.09,27.62,12.48,42.53,14.41,15.71,2,31.67,1.19,47.3-1.09,7.85-1.15,15.69-3.07,23.66-3,6.73,0,13.37,1.74,17.86,7,3.2,3.77,5.41,9.57,3.34,14.38-2.46,5.75-9.42,7-15,7.25-7.38.39-14.7.14-22,1.67-6.94,1.47-13.85,4.48-18.63,9.88-4.21,4.76-7.11,11.21-6.53,17.66a19.34,19.34,0,0,0,9.67,14.84c5.35,3.21,11.65,4.42,17.75,5.19,7.88,1,15.82,1.52,23.7,2.43q26.08,3,51.85,8.21,6.24,1.25,12.44,2.62C510.65,419.44,511.77,415.42,509.14,414.84Z"/>
      <path fill="none" class="cls-2" d="M250.18,136.91c16.82-2.39,33.92-4.45,58.19,3a9.66,9.66,0,0,0,9.58-2.82,5.68,5.68,0,0,0,.46-.64c4.58-8.35,5.27-14.52,5.33-24A24.37,24.37,0,0,0,303.3,88.22c-19-3.14-37.05-3.11-53-.06a54.06,54.06,0,0,0-9.94,43.65A9.59,9.59,0,0,0,250.18,136.91Z"/>
      <path class="cls-1" d="M293.25,66.85a53.93,53.93,0,0,0-43,21.31c16-3,34-3.08,53,.06a24.37,24.37,0,0,1,20.44,24.15c-.06,9.52-.75,15.69-5.33,24a5.68,5.68,0,0,1-.46.64,9.66,9.66,0,0,1-9.58,2.82c-24.27-7.41-41.37-5.35-58.19-3a9.59,9.59,0,0,1-9.86-5.1,53.87,53.87,0,0,0,7.09,17.7c16.29-2.16,45.38-3.2,84.46,9.17a54,54,0,0,0-38.62-91.83Z"/>
      <path class="cls-3" d="M81.91,11.64a5.05,5.05,0,0,0,5-5,5,5,0,0,0-10,0,5.09,5.09,0,0,0,5,5Z"/>
      <path class="cls-3" d="M485.13,143.93a5,5,0,1,0-5-5,5,5,0,0,0,5,5Z"/>
      <path class="cls-3" d="M112.25,84.46a5,5,0,1,0-5-5,5.05,5.05,0,0,0,5,5Z"/>
      <path class="cls-3" d="M6.67,217.27a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z"/>
      <path class="cls-3" d="M372.65,161a1.57,1.57,0,0,0,0-3.13,1.57,1.57,0,0,0,0,3.13Z"/>
      <path class="cls-3" d="M454.79,313.15a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z"/>
      <path class="cls-3" d="M72.51,21.86a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z"/>
      <path class="cls-3" d="M415.45,614.73c3.92,0,7.68-3.45,7.5-7.5a7.63,7.63,0,0,0-7.5-7.5c-3.93,0-7.68,3.45-7.5,7.5a7.63,7.63,0,0,0,7.5,7.5Z"/>
    </svg>
    <div>
      <h2 class="h2-404">{{getNotFound.sub1}}</h2>
      <p class="text-404">{{getNotFound.p1}}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NotFound',
  computed: {
    ...mapGetters(['getNotFound'])
  }
}
</script>

<style scoped>
.container-404 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100vh;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.heading-404 {
  font-weight: 800;
  font-size: 2.25rem;
  line-height: 2.5rem;
  margin-bottom: 2rem;
}
.img-404 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  max-width: 300px;
}
.h2-404 {
  font-weight: 800;
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-404 {
  margin-top: 1rem;
}
.astronaut .cls-1, .astronaut .cls-3 {
  fill: var(--primary) !important;
}
</style>
